module.exports = __webpack_public_path__ + "img/loading.cdae69e2.gif";